export default "/images/cpu.svg?3ea45c8b4d3f76fbaa7b1fe5d36d09af";